/**
 * Fallback handler: stt-ws-fail
 *
 * Fires on a `server.error` carrying `voice_unavailable` — the socket
 * accepted the spoken turn and refused to run it, because the deployment
 * has no priced speech backend or the clip was empty or over the 30-second
 * ceiling.
 *
 * The copy no longer mentions the network. It used to, from a design where
 * speech had its own WebSocket that could fail to open; audio now rides
 * the same metered stage socket as everything else, so by the time this
 * banner can appear the connection is demonstrably working. Telling a
 * visitor to check their network would send them to fix the one thing that
 * is not broken.
 *
 * It also does not name a cause. The visitor cannot distinguish "this
 * deployment has no speech provider" from "that clip ran long", and only
 * one of those is theirs to act on, so the message points at the path that
 * definitely works instead of guessing.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeSttWsFailBanner(onRetry: () => void): FallbackBanner {
  return {
    kind: "stt-ws-fail",
    message: "Speech isn't getting through right now. You can keep going by typing.",
    retryAction: onRetry,
    retryLabel: "Try again",
  };
}
